import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
  validateSearch: (search) => ({
    redirect: search.redirect || "/",
  }),
  beforeLoad: async ({ context, search }) => {
    if (context.auth) {
      throw redirect({ to: search.redirect });
    }
  },
  component: () => <Outlet />,
});
